import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Card from '../common/Card';
import Button from '../common/Button';
import api from '../../services/api';
import { formatCurrency, formatDate } from '../../utils/formatters';
import '../../styles/subscription.css';

const SubscriptionDetails = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSubscription();
  }, []);

  const loadSubscription = async () => {
    try {
      const response = await api.get('/subscription.php/current');
      setSubscription(response.data);
    } catch (error) {
      console.error('Failed to load subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading subscription details...</div>;
  }

  const modules = subscription?.modules || user?.modules || [];
  const monthlyTotal =
    subscription?.monthly_total ?? user?.modules_monthly_total ?? 0;

  return (
    <div className="subscription-details">
      <h1>Subscription & Apps</h1>
      
      <Card>
        <div className="subscription-info">
          <div className="info-row">
            <label>Business:</label>
            <span>{user?.business_name}</span>
          </div>
          <div className="info-row">
            <label>Status:</label>
            <span className={`status-badge ${subscription?.subscription_status || user?.subscription_status}`}>
              {subscription?.subscription_status || user?.subscription_status}
            </span>
          </div>
          {(subscription?.trial_ends_at || user?.subscription_status === 'trial') && (
            <div className="info-row">
              <label>Trial Ends:</label>
              <span className="trial-end">{formatDate(subscription?.trial_ends_at)}</span>
            </div>
          )}
          <div className="info-row">
            <label>Monthly total:</label>
            <span className="price">{formatCurrency(monthlyTotal)}/month</span>
          </div>
        </div>

        <div className="features-list">
          <h3>Active Apps</h3>
          {modules.length === 0 ? (
            <p>No apps selected yet. Choose the modules you need.</p>
          ) : (
            <ul>
              {modules.map((m) => (
                <li key={m.id || m.module_code}>
                  {m.icon || '✓'} {m.module_name} — {formatCurrency(m.price_monthly)}/mo
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="subscription-actions">
          <Button
            variant="primary"
            onClick={() => navigate('/settings/subscription/plans')}
          >
            {modules.length ? 'Change Apps' : 'Choose Apps'}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionDetails;
